// extracted by mini-css-extract-plugin
export default {"error":"RYU7IFkkJTSsA3M26ppo","verifiedSection":"M_LvjiLQeZgT7l5r5Vai"};